module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unit-input"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayValue),
      expression: "displayValue"
    }],
    staticClass: "addon"
  }, [_c('span', {
    staticClass: "hidden"
  }, [_vm._v(_vm._s(_vm.displayValue))]), _vm._v(" "), _c('span', {
    staticClass: "unit-mark"
  }, [_vm._v(_vm._s(_vm.mark))])]), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.displayValue
    },
    on: {
      "input": _vm.onInput,
      "change": _vm.onChange
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f8ee07a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/UnitInput.vue
// module id = 570
// module chunks = 1